import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useClient } from '../connect_api';
import { ActuatorInfo, MachineService } from '../api/api_pb';
import RelativeTime from '../components/RelativeTime';
import { toast } from 'react-toastify';
import EditActuatorModal from '../components/EditActuatorModel';

const LockerActuators: React.FC = () => {
    const { machineUuid } = useParams();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [actuators, setActuators] = useState<ActuatorInfo[]>([]);
    const [showEditModal, setShowEditModal] = useState(false);
    const [actuator, setActuator] = useState<ActuatorInfo | null>(null);


    const machineClient = useClient(MachineService);

    const fetchActuatorsData = useCallback(async () => {
        setIsLoading(true);
        try {
            try {
                const response = await machineClient.listMachineActuators({
                    machineUuid: machineUuid,
                });
                setActuators(response.actuators);
            } catch (e) {
                toast.dismiss();
                toast.error('Failed to fetch data');
                console.log('error', e);
            }
        } catch (err) {
            toast.dismiss();
            toast.error('Failed to fetch data');
            console.log('error', err);
        } finally {
            setIsLoading(false);
        }
    }, [machineClient, machineUuid]);

    useEffect(() => {
        fetchActuatorsData();
    }, [machineUuid, fetchActuatorsData]);


    const handleCreateModal = () => {
        setActuator(null);

        setShowEditModal(true);
    };

    const handleEditModal = (actuator: ActuatorInfo) => {
        setActuator(actuator);

        setShowEditModal(true);
    };

    const handleDeleteModal = (actuator: ActuatorInfo) => {
        window.confirm(`Are you sure you want to delete actuator ${actuator.identity}?`) && machineClient.deleteMachineActuator({
            uuid: actuator.uuid
        }).then(() => {
            toast.dismiss();
            toast.success('Actuator deleted successfully');
            fetchActuatorsData();
        }).catch((err) => {
            toast.dismiss();
            toast.error('Failed to delete actuator');
            console.log('error', err);
        })
    };

    const handleCloseModal = () => {
        setShowEditModal(false);
        setActuator(null);
    };


    return (
        <div className="p-4">
            {isLoading ? (
                <div className="text-center">Loading...</div>
            ) : (
                <>
                    <div className="flex justify-end items-center mb-4">
                        <button onClick={() => handleCreateModal()} className="bg-green-500 text-white px-4 py-2 rounded mb-4">
                            Create Actuator
                        </button>
                    </div>

                    <table className="w-full border-collapse border border-gray-200">
                        <thead>
                            <tr className="bg-gray-100">
                                <th className="border text-left border-gray-300 p-2">UUID</th>
                                <th className="border text-left border-gray-300 p-2">Identity</th>
                                <th className="border text-left border-gray-300 p-2">IPAddress:Port</th>
                                <th className="border text-left border-gray-300 p-2">Sequence</th>
                                <th className="border text-left border-gray-300 p-2">Created At</th>
                                <th className="border text-left border-gray-300 p-2">Updated At</th>
                                <th className="border p-2">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {actuators.length === 0 ? (
                                <tr>
                                    <td colSpan={7} className="border border-gray-300 p-2 text-center">No data available</td>
                                </tr>
                            ) : (
                                actuators.map(item => (
                                    <tr key={item.uuid}>
                                        <td className="border border-gray-300 p-2">{item.uuid}</td>
                                        <td className="border border-gray-300 p-2">{item.identity}</td>

                                        <td className="border border-gray-300 p-2">
                                            {item.ipAddress}:{item.port}
                                        </td>
                                        <td className="border border-gray-300 p-2">
                                            {item.sequence}
                                        </td>
                                        <td className="border border-gray-300 p-2">
                                            {item.createdAt ? (
                                                <div className="text-sm">
                                                    <div><RelativeTime timestamp={item.createdAt} /></div>
                                                </div>
                                            ) : ''}
                                        </td>
                                        <td className="border border-gray-300 p-2">
                                            {item.updatedAt ? (
                                                <div className="text-sm">
                                                    <div><RelativeTime timestamp={item.updatedAt} /></div>
                                                </div>
                                            ) : ''}
                                        </td>
                                        <td className="border p-2">
                                            <button
                                                className="btn btn-primary me-2"
                                                onClick={() => handleEditModal(item)}
                                            >
                                                Edit
                                            </button>

                                            <button
                                                className="btn btn-danger"
                                                onClick={() => handleDeleteModal(item)}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </>
            )}

            {showEditModal && (
                <EditActuatorModal
                    isOpen={showEditModal}
                    onClose={() => handleCloseModal()}
                    machineUuid={machineUuid || ''}
                    onActuatorUpdated={fetchActuatorsData}
                    actuator={actuator}
                    isEdit={actuator !== null}
                />
            )}
        </div>
    );
};

export default LockerActuators;
